module.exports = __webpack_public_path__ + "img/panelView_defaultBg_strong_2_2.262aa2a0.png";